import V from 'voUtils/V.js';
import QuoteTools from 'voUtils/QuoteTools.js';

import {
	doReq
}
from 'voUtils/RestEx.js';
import {
	fireQuote, fireUnitAction, fireCheckout
}
from 'voUtils/TagEx.js';
import {
	find, filter, isEmpty, oneIs
}
from 'voUtils/tools.js';

import {
	setVoucher, getVoucher
}
from 'voUtils/VoucherStore.js';
import DateEx from 'voUtils/DateEx.js';

export default {

	data: {
		bookingData: {
			adults: 2,
			children: 0,
			childrenAges: undefined,
			babys: 0,
			petsCount: 0,
			from: undefined,
			till: undefined
		},
		action: undefined,
		step: undefined, //'booking',
		priceIsUpdated: false,
		showPriceDetails: false,
		quote: {},
		error: undefined,
		preview: undefined,
		summary: undefined,
		voucher: getVoucher(),
		selectedImageIndex: undefined,
		oroCookie: false,
		orocardnumber: undefined,
		orocardexists: false
	},
	created: function () {
		this.calListeners = [];
		this.priceListeners = [];
		this.QuoteTools = QuoteTools;

		var params = new URLSearchParams(new URL(window.location).search);
		for (let [k, v] of params) {
			if (oneIs(k, 'ref_adults', 'ref_children', 'ref_babys', 'ref_from', 'ref_till')) {
				this.bookingData[k.substring(4)] = v;
			}
		}

		var hash = window.location.hash;
		if (hash) {
			hash = hash.substring(1);

			let url = new URL(hash, 'https://www.v-office.com');
			let params = new URLSearchParams(url.search);

			for (let p of params) {
				if ((p[0] == 'children' || p[0] == 'babys') && !this.areChildrenWelcome()) {
					//ignore not welcome
				} else if (p[0] == 'petsCount' && !this.arePetsWelcome()) {
					//ignore not welcome
				} else {
					this.bookingData[p[0]] = p[1];
				}
			}
		}
		//console.log("Cookie::", this.getCookie("orocard"));
		if (this.getCookie("orocard")) {
			console.log('Cookie true', this.voucher);
		} else {
			var voucher = getVoucher();
			console.log('Cookie false', this.voucher);
			if (voucher && voucher.code === 'oro7') {
				localStorage.removeItem('voucher_code');
				localStorage.removeItem('voucher_name');
				localStorage.removeItem('voucher_validated');
				console.log('delete voucher-code');
			}
		}



		this.updatePrices();
	},
	computed: {
		showBookingButtons: function () {
			return this.quote && this.quote.mandatory && !this.priceIsUpdated && isEmpty(this.quote.errors) && !this.action;
		},
		canDoNext: function () {
			return this.quote && this.quote.mandatory && !this.priceIsUpdated && isEmpty(this.quote.errors) && this.action;
		},
		periodLabel: function () {
			let label = '';
			if (this.bookingData.from) {
				label = this.voFormatDate(this.bookingData.from, 'withDay');
			}
			if (this.bookingData.till) {
				label += ' - ' + this.voFormatDate(this.bookingData.till, 'withDay');
			}

			return label;
		},
		guestLabel: function () {
			var sd = this.bookingData;
			var amount = ((sd.adults || 0) - 0) + ((sd.children || 0) - 0) + ((sd.babys || 0) - 0);
			var label = amount + ' ' + this.voMsgPl('guest.pl', amount);
			if (sd.petsCount) {
				label += ', ' + sd.petsCount + ' ' + this.voMsgPl('pet.pl', sd.petsCount);

			}
			return label;
		}


	},

	updated: function () {
		$(".owl-carousel.owl-carousel-similarunits").owlCarousel({
			items: 3,
			loop: true,
			margin: 30,
			autoplay: false,
			nav: true,
			responsive: {
				0: {
					items: 1,
					nav: true
				},
				600: {
					items: 2,
					margin: 15
				},
				1000: {
					items: 3,
					nav: true
				}
			}
		});

		$('#pd_input_title').on('change invalid', function () {
			var title = $(this).get(0);

			title.setCustomValidity('');

			if (!title.validity.valid) {
				title.setCustomValidity('Bitte füllen Sie dieses Feld aus.');
			}
		});
		$('#pd_input_forename').on('change invalid', function () {
			var forename = $(this).get(0);

			forename.setCustomValidity('');

			if (!forename.validity.valid) {
				forename.setCustomValidity('Bitte füllen Sie dieses Feld aus.');
			}
		});
		$('#pd_input_surname').on('change invalid', function () {
			var surname = $(this).get(0);

			surname.setCustomValidity('');

			if (!surname.validity.valid) {
				surname.setCustomValidity('Bitte füllen Sie dieses Feld aus.');
			}
		});

		$('#pd_input_street').on('change invalid', function () {
			var street = $(this).get(0);

			street.setCustomValidity('');

			if (!street.validity.valid) {
				street.setCustomValidity('Bitte füllen Sie dieses Feld aus.');
			}
		});

		$('#pd_input_housenumber').on('change invalid', function () {
			var housenumber = $(this).get(0);

			housenumber.setCustomValidity('');

			if (!housenumber.validity.valid) {
				housenumber.setCustomValidity('Bitte füllen Sie dieses Feld aus.');
			}
		});

		$('#pd_input_postalcode').on('change invalid', function () {
			var postalcode = $(this).get(0);

			postalcode.setCustomValidity('');

			if (!postalcode.validity.valid) {
				postalcode.setCustomValidity('Bitte füllen Sie dieses Feld aus.');
			}
		});
		$('#pd_input_city').on('change invalid', function () {
			var city = $(this).get(0);

			city.setCustomValidity('');

			if (!city.validity.valid) {
				city.setCustomValidity('Bitte füllen Sie dieses Feld aus.');
			}
		});

		$('#pd_input_country').on('change invalid', function () {
			var country = $(this).get(0);

			country.setCustomValidity('');

			if (!country.validity.valid) {
				country.setCustomValidity('Bitte füllen Sie dieses Feld aus.');
			}
		});

		$('#pd_input_email').on('change invalid', function () {
			var textfield = $(this).get(0);

			// 'setCustomValidity not only sets the message, but also marks
			// the field as invalid. In order to see whether the field really is
			// invalid, we have to remove the message first
			textfield.setCustomValidity('');

			if (!textfield.validity.valid) {
				textfield.setCustomValidity('Bitte geben Sie eine korrekte E-Mail Adresse ein.');
			}
		});

		$('#pd_input_mobile').on('change invalid', function () {
			var mobile = $(this).get(0);

			mobile.setCustomValidity('');

			if (!mobile.validity.valid) {
				mobile.setCustomValidity('Bitte füllen Sie dieses Feld aus.');
			}
		});
		$('#ck_privacy1').on('change invalid', function () {
			var chekbox = $(this).get(0);

			chekbox.setCustomValidity('');

			if (!chekbox.validity.valid) {
				chekbox.setCustomValidity('Bitte füllen Sie dieses Feld aus.');
			}
		});
		$('#ck_gtc').on('change invalid', function () {
			var chekbox = $(this).get(0);

			chekbox.setCustomValidity('');

			if (!chekbox.validity.valid) {
				chekbox.setCustomValidity('Bitte füllen Sie dieses Feld aus.');
			}
		});

		/*$('#latestfeedback div.feedback').hide();
		$('#latestfeedback div.feedback:last').show();*/
		$('.feedback:empty').remove();

	},

	methods: {
		displayOroCardField: function () {
			if (!this.oroCookie) {
				return true;
			} else {
				return false;
			}
		},
		showOroNumberField: function () {
			if (this.orocardexists) {
				$('.oro-card-number').css({
					'display': 'block'
				});
			} else {
				console.log('is nicht checked');
				$(".ororesult").html('');
				$('.oro-card-number').css({
					'display': 'none'
				});
				$('.ororesult').css({
					'display': 'none'
				});
				var voucher = getVoucher();
				if (voucher && voucher.code === 'oro7') {
					localStorage.removeItem('voucher_code');
					localStorage.removeItem('voucher_name');
					localStorage.removeItem('voucher_validated');
					//console.log('Deleted Oro Voucher Code');
					this.voucher = false;
					this.updatePrices();
				}
			}
		},
		checkOroCardNumber: function () {
			let result = "";
			let oronumber = this.orocardnumber;
			let success = false;
			let voucherData = {
				code: 'oro7',
				name: 'ORO-CARD'
			};
			if (oronumber) {
				var data = {
					orocardnr: oronumber, // 1SpnF3IB ist aktuell gültig
				};

				var url = "https://www.ostseeresortolpenitz.de/api/orocardValid.json";

				$.ajax({
						type: 'POST',
						url: url,
						data: data,
						success: success,
						async: false
					}).done(function (response) {
						//console.log(response);
						if (response.data && response.data.success === true) {
							result = "Die ORO-CARD-Nr. ist gültig. Sie erhalten den 5% Wiederkommer-Rabatt!";
							success = true;

							$(".ororesult").fadeIn();
							$(".ororesult").html(result);

						}
					})
					.fail(function () {
						result = 'Die ORO-CARD-Nr.: "' + oronumber + '" konnte nicht gefunden werden';
						$(".ororesult").fadeIn();
						$(".ororesult").html(result);
					});

				//console.log('success::', success);

				if (success) {
					// die ORO-CARD-NR ist für 30 Minuten gültig
					this.setCookie("orocard", true, 30);
					setVoucher(voucherData);
					this.voucher = voucherData;
					this.updatePrices();

				} else {
					var voucher = getVoucher();
					if (voucher && voucher.code === 'oro7') {
						localStorage.removeItem('voucher_code');
						localStorage.removeItem('voucher_name');
						localStorage.removeItem('voucher_validated');
						//console.log('Deleted Oro Voucher Code');
						this.voucher = false;
						this.updatePrices();
					}

				}
			} else {
				result = 'Bitte tragenSie Ihre ORO-CARD-Nr. ein.';
				$(".ororesult").fadeIn();
				$(".ororesult").html(result);
			}
		},

		setCookie: function (cname, cvalue, exminutes) {
			const d = new Date();
			d.setTime(d.getTime() + exminutes * 60 * 1000);
			let expires = "expires=" + d.toUTCString();
			document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		},
		getCookie: function (cname) {
			let name = cname + "=";
			let decodedCookie = decodeURIComponent(document.cookie);
			let ca = decodedCookie.split(";");
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == " ") {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		},

		isNavbarDisrupterExist: function () {
			var name = "navbarheader=";
			var ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return false;
				}
			}
			return true;

		},
		getPrices: function (done) {
			if (this.prices) {
				console.log('Prices schon da');
				done(this.prices);
			} else {
				this.priceListeners.push(done);

				if (this.priceListeners.length === 1) {

					var req = {
						id: this.getUnitId()
					};

					var params = {
						'noCache': true
					};

					doReq('getPricelist', req, params)
						.then((res) => {
							this.prices = res.prices;

							for (let l of this.priceListeners) {
								l(res.prices);
							}
							this.priceListeners.length = 0;
						});


				}
			}
		},
		canShowGoogleMaps: function () {
			var GoogleMaps = localStorage.getItem("allowGoogleMaps");
			if (GoogleMaps === 'true') {
				return true;
			}
			return false;
		},
		checkVoucherCode: function (code) {
			if (code) {
				if (this.voucher && code === this.voucher.code) {
					return true;
				} else {
					return false;
				}

			} else {
				return true;
			}
		},
		hideDateWarning: function () {
			//$("#datewarning").hide();
			$('#datewarning').removeClass('warning-popup');
		},
		addLine: function (quote, sl) {
			QuoteTools.addLine(quote, sl);
			this.$forceUpdate();
		},
		removeLine: function (quote, sl) {
			QuoteTools.removeLine(quote, sl);
			this.$forceUpdate();
		},
		clearPrices: function () {
			this.quote = {};
			this.summary = undefined;
			this.preview = undefined;
			this.previewQuote = undefined;
		},
		updatePrices: function () {

			var data = this.bookingData;
			this.error = undefined;
			if (data.from && data.till) {

				this.priceIsUpdated = true;
				this.quote = {};

				var req = {
					fromdate: DateEx.interfaceFormat(data.from),
					tilldate: DateEx.interfaceFormat(data.till),
					adults: data.adults,
					children: data.children,
					babys: data.babys,
					petsCount: data.petsCount,
					unit: this.getUnitId()
				};

				if (VOFFICE.quoteOptions) {
					Object.assign(req, VOFFICE.quoteOptions);
				}

				if (this.voucher) {
					req.voucherCode = this.voucher.code;
				}

				if (VOFFICE.abtest) {
					req.abtest = VOFFICE.abtest;
				}

				if (data.childrenAges) {
					req.childrenAges = data.childrenAges;
				}

				doReq('quotePrices', req)
					.then((res) => {
						this.quote = res.quote;
						this.priceIsUpdated = false;
						this.quote.optional.forEach(sl => {
							sl.optional = true;
							sl.amount = null;
							this.QuoteTools.updateTotal(sl);
						});
						this.quote.onsiteOptional.forEach(sl => {
							sl.onsiteOptional = true;
							sl.amount = null;
							this.QuoteTools.updateTotal(sl);
						});
						this.quote.usage.forEach(sl => {
							sl.usage = true;
							sl.amount = null;
							this.QuoteTools.updateTotal(sl);
						});


						if (res.quote.mandatory) {
							this.summary = find(res.quote.mandatory, function (sl) {
								return sl.service.type === 'SUMMARY';
							});

							this.preview = filter(res.quote.mandatory, function (sl) {
								return !VOFFICE.hideTypeOnPricePreview || VOFFICE.hideTypeOnPricePreview.indexOf(sl.service.type) == -1;
							});

							if (!this.preview || this.preview.length < 2) {
								this.preview = undefined;
								this.previewQuote = undefined;
							} else {
								this.previewQuote = {
									mandatory: this.preview,
									hasDiscounts: this.quote.hasDiscounts
								};
							}

						}

						fireQuote(this.getCart());

					})
					.catch(e => {
						this.priceIsUpdated = false;
						this.error = e;
					});


			}

		},
		getCart: function () {
			return {
				action: this.action,
				quote: this.quote,
				booking: Object.assign({}, this.bookingData),
				unitId: this.getUnitId()
			};
		},

		goAction: function (action) {
			this.action = action;
			this.showPriceDetails = true;
			fireUnitAction(this.getCart());
		},

		putInCart: function () {
			this.step = 'booking';
			fireCheckout(this.getCart());
			window.scrollTo(0, 0);

		},
		cancelBooking: function () {
			this.step = undefined;
		},
		cancel: function () {
			this.action = undefined;
			this.showPriceDetails = false;

		},


		getUnitId: function () {
			if (!this.unitId) {
				let el = document.querySelector("[data-unit-id]");
				if (el) {
					this.unitId = parseInt(el.getAttribute('data-unit-id'), 10);
				}
			}
			return this.unitId;
		},
		areChildrenWelcome: function () {
			if (this.childrenWelcome == undefined) {
				let el = document.querySelector("[data-children-welcome]");
				if (el) {
					this.childrenWelcome = el.getAttribute('data-children-welcome') == '1';
				} else {
					this.childrenWelcome = false;
				}
			}
			return this.childrenWelcome;
		},
		arePetsWelcome: function () {
			if (this.petsWelcome == undefined) {
				let el = document.querySelector("[data-pets-welcome]");
				if (el) {
					this.petsWelcome = el.getAttribute('data-pets-welcome') == '1';
				} else {
					this.petsWelcome = false;
				}
			}
			return this.petsWelcome;
		},
		getCal: function (done) {
			if (this.cal) {
				done(this.cal);
			} else {
				this.calListeners.push(done);

				if (this.calListeners.length === 1) {

					var req = {
						unit: this.getUnitId()
					};

					doReq('getCal', req)
						.then((res) => {
							this.cal = res.cal;

							for (let l of this.calListeners) {
								l(res.cal);
							}
							this.calListeners.length = 0;

						});
				}
			}


		}
	},
	watch: {
		'bookingData.from': function () {
			if (!this.bookingData.till) {
				this.clearPrices();
			}
		},
		'bookingData.till': function (val) {
			if (val) {
				var endDate = new Date(val);
				var fromDate = new Date(this.bookingData.from);
				var fromDay = fromDate.getDay();
				var endDay = endDate.getDay();
				if (endDay == 6 || fromDay == 6) {
					//$('#datewarning').show();
					$('#datewarning').addClass('warning-popup');
				} else {
					//$('#datewarning').hide();
					$('#datewarning').removeClass('warning-popup');
				}
			} else {
				//$('#datewarning').hide();
				$('#datewarning').removeClass('warning-popup');
			}
		},

	}
};